import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_ROUTER_PERMISSIONS = [
  PermissionsEnum.api_view_nodo,
  PermissionsEnum.api_view_olt,
];
